<bn-alerts [removerTodosClick]="removerAlertasService.removerTodosClick"></bn-alerts> -->

<bn-loading-overlay></bn-loading-overlay>
<bn-header class="titulo" [titulo]="obterTitulo() | async"></bn-header>
<bn-container [exibirAside]="false">
    <bn-nav *ngIf="menuVisivel" [class]="estiloMenu" nav [itens]="itensMenu$"></bn-nav> 
    <router-outlet main></router-outlet>
    <div aside></div>
</bn-container>